// src/pages/DebriefTable/styled.js
import styled from "styled-components";
import moreIcon from "../../images/C_moree.svg";
import optionsBlue from "../../images/C_optionn.svg";
import downloadIcon from "../../images/c_download.svg";
import downloadIconBlue from "../../images/c_download_blue.svg";

export const MainDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  border: 1px solid #ADB8AE;
  border-radius: 8px;
  background-color: #ffffff;
`;
export const OptionButton = styled.button`
  height: 32px;
  width: 32px;

  background: #DEE2EF;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:after {
      content: url(${moreIcon});
      display: block;
      height: 32px;
      width: 32px;
  }

  &:hover {
    &:after {
      content: url('${optionsBlue}');
      display: block;
      height: 32px;
      width: 32px;
    }
  }
`;

export const DownloadAssessmentButton = styled.button`
  height: 32px;
  width: 32px;
  background: #DEE2EF;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:after {
    content: ${({ $loading }) => ($loading ? "none" : `url(${downloadIcon})`)};
    display: block;
    height: 32px;
    width: 32px;
  }

  &:hover:not(:disabled):not(.disabled) {
    &:after {
      content: url(${downloadIconBlue});
      display: block;
      height: 32px;
      width: 32px;
    }
  }

  &:disabled,
  &.disabled {
    opacity: 0.95;
    cursor: not-allowed;
    filter: grayscale(80%);
  }
`;

export const ContentWrapDiv = styled.div`
  height: calc(100vh);
  margin-top: 0;
  width: 100%;
  padding: 18px;
  overflow: auto;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 20px;

  .leftSide {
    width: 217px;
    height: 29px;
    font-weight: 700;
    font-size: 20px;
    line-height: 29.05px;
    color: #1E2228;
  }

  .rightSide {
    display: flex;
    gap: 10px;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  align-items: center;

//   .ant-select,
//   .ant-input {
//     font-size: 13px;
//     height: 38px;
//   }

  .ant-select-selector {
    border-radius: 6px !important;
    border-color: #d1d5db !important;
  }
`;

export const ResultsSummary = styled.div`
  background: #f3f4f6;
  border-left: 4px solid #1b49ea;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;

  .summary-text {
    font-size: 13px;
    color: #374151;
    font-weight: 600;
    margin-bottom: 8px;

    .filter-count {
      color: #1b49ea;
      margin-left: 4px;
    }
  }

  .filter-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .ant-tag {
      cursor: pointer;
      font-size: 12px;
    }
  }
`;

export const CandidateDetailsSection = styled.div`
  background: linear-gradient(135deg, #f0f4ff 0%, #f9fafb 100%);
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  h3 {
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
    color: #1e2228;
  }
`;

export const CandidateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
`;

export const CandidateCard = styled.div`
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  transition: all 0.2s ease;

  &:hover {
    border-color: #1b49ea;
    box-shadow: 0 2px 8px rgba(27, 73, 234, 0.1);
  }

  .avatar-wrapper {
    flex-shrink: 0;
  }

  .candidate-info {
    flex: 1;
    min-width: 0;

    .name {
      font-weight: 600;
      font-size: 13px;
      color: #1e2228;
      margin-bottom: 4px;
    }

    .email,
    .phone {
      display: block;
      font-size: 12px;
      color: #1b49ea;
      text-decoration: none;
      word-break: break-all;
      margin-bottom: 2px;

      &:hover {
        text-decoration: underline;
      }
    }

    .phone {
      color: #6b7280;
    }
  }
`;

export const TableWrap = styled.div`
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border-bottom: none;
  border-radius: 8px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;

  .text-truncate {
    max-width: 150px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
`;

export const MainTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  & th {
    height: 52px;
    background: #F2F6F8;
    font-weight: 700;
    padding: 4px 15px;
    text-align: left;
    font-size: 12px;
    white-space: nowrap;

    &:first-child {
      border-top-left-radius: 8px;
    }

    &:last-child {
      border-top-right-radius: 8px;
    }

    &.sticky-th-1 {
      position: sticky;
      left: 0;
      z-index: 11;
      background: #F2F6F8;
      min-width: 160px;
    }

    &.sticky-th-2 {
      position: sticky;
      left: 160px;
      z-index: 11;
      background: #F2F6F8;
      min-width: 100px;
    }

    &.sticky-th-3 {
      position: sticky;
      left: 270px;
      z-index: 11;
      background: #F2F6F8;
      min-width: 100px;
    }
  }

  & tr {
    border: 1px solid #dfe9ef;
  }

  & td {
    height: 52px;
    border-bottom: 1px solid #dfe9ef;
    margin: 0px;
    padding: 4px 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.51px;
    white-space: nowrap;
    vertical-align: middle;

    &.sticky-col-1 {
      position: sticky;
      left: 0;
      z-index: 1;
      background: white;
      min-width: 160px;
    }

    &.sticky-col-2 {
      position: sticky;
      left: 160px;
      z-index: 1;
      background: white;
      min-width: 100px;
    }

    &.sticky-col-3 {
      position: sticky;
      left: 270px;
      z-index: 1;
      background: white;
      min-width: 100px;
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;

  button {
    width: 36px;
    height: 36px;
    padding: 8px;
    // border: 1px solid #d1d5db;
    background: white;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #374151;
    font-size: 14px;
    transition: all 0.2s ease;

    // &:hover:not(.disabled) {
    //   background: #1b49ea;
    //   color: white;
    //   border-color: #1b49ea;
    // }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80%;
  gap: 4px;
  color: #6b7280;
  padding: 40px 20px;

  .empty-icon {
    font-size: 48px;
    opacity: 0.5;
  }

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #374151;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #9ca3af;
  }
      button {
    margin-top: 8px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  margin-top: 8px;
  gap: 16px;  // ✅ Add gap for spacing

  .left-section {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #6b7280;
    font-weight: 400;
    flex-wrap: wrap;  // ✅ Allow wrapping on small screens

    span {
      white-space: nowrap;
    }

    .divider {
      color: #d1d5db;
      margin: 0 6px;
      opacity: 0.6;
    }

    .results-count {
      color: #374151;
      font-weight: 600;
      white-space: nowrap;
    }
  }

  .page-controls {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;  // ✅ Prevent shrinking

    button {
      min-width: 28px;
      height: 28px;
      padding: 0 6px;
      border: 1px solid #d1d5db;
      background: white;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      color: #374151;
      font-weight: 500;
      white-space: nowrap;
      transition: all 0.15s ease;

      &:hover:not(.disabled) {
        border-color: #1b49ea;
        background: #f0f4ff;
        color: #1b49ea;
      }

      &.active {
        background: #1b49ea;
        color: white;
        border-color: #1b49ea;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .ellipsis {
      padding: 0 4px;
      color: #9ca3af;
      user-select: none;
      font-size: 12px;
      line-height: 28px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;

    .page-controls {
      width: 100%;
      justify-content: flex-start;
    }
  }
`;
export const PaginationSelectWrapper = styled.div`
  .ant-select-selector {
    height: 38px !important;
    border-radius: 8px !important;
    border: 1px solid #E5E7EB !important;
    background: #FFFFFF !important;
    padding: 0 10px !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    font-size: 13px !important;
    color: #374151 !important;
    font-weight: 400 !important;

    box-shadow: none !important;
    transition: all 0.15s ease !important;
  }

  &:hover .ant-select-selector {
    border-color: #D1D5DB !important;
  }

  .ant-select-focused .ant-select-selector {
    border-color: #4F46E5 !important;
  }

  .ant-select-selection-item {
    line-height: 34px !important;
  }

  .ant-select-arrow {
    color: #6B7280 !important;
  }
`;

export const DebriefDropdown = styled.div`
  .ant-dropdown-menu-item {
    pointer-events: none;
    padding: 0;

    &:hover {
      background: transparent;
    }
  }
`;

export const IconDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  & button , img {
    border-radius: 6px;
  }
`;